import Script from 'next/script';
import { GetStaticProps, NextPage } from 'next';
import { CSSProperties } from 'react';
import { HeaderNav } from 'interfaces/navigation/Header';
import { safeAsync } from 'utils/errorHandlingUtils';
import getMenu from 'api/Header/getMenu';
import fallbackData from 'lib/fallbackData/commonData';
import getFooter from 'api/Footer/getFooter';
import mockPageData from 'lib/mockData/page-data';
import { ArcSpanPageConfig } from 'services/ArcSpan/entities';
import { setarcSpanPageConfig } from 'services/ArcSpan';
import { PianoPageConfig } from 'services/Piano/entities/PianoPageConfig';
import { setMockPianoConfig } from 'services/Piano';
import { mockHeadData } from 'utils/metaDataUtils/headData';
import handleStaticPropsError from 'utils/handleStaticPropsError';

const AdvertisingPage: NextPage = () => {
  const advertStyle: CSSProperties = {
    border: '0 none',
    bottom: '0',
    height: '0',
    left: '0',
    margin: '0',
    padding: '0 0 129.69%',
    position: 'relative',
    right: '0',
    top: '0',
    width: 'auto',
  };

  const iframeStyle: CSSProperties = {
    border: '0 none',
    bottom: '0',
    height: '1px',
    left: '0',
    margin: '0',
    minHeight: '100%',
    minWidth: '100%',
    padding: '0',
    position: 'absolute',
    right: '0',
    top: '0',
    width: '1px',
  };

  return (
    <>
      <div
        style={advertStyle}
        id='experience-676ebdbbaea2d'
        data-aspectRatio='0.77108434'
        data-mobile-aspectRatio='0.29250457'
        data-tablet-aspectRatio='0.37440585'
      >
        <iframe
          allowFullScreen
          src='https://view.ceros.com/fortune-magazine/advertising?mobileHeightOverride=1&tabletHeightOverride=2'
          style={iframeStyle}
          frameBorder='0'
          className='ceros-experience'
          title='Advertising Landing Page-Final'
          scrolling='no'
        />
      </div>
      <Script
        src='https://labs.ceros.com/sdk-plugins/utm-parameters/main.js?v=2'
        id='utm-param-plugin'
        data-params-to-pass='utm_source,utm_medium,utm_campaign,utm_term,utm_content'
        strategy='beforeInteractive'
      />
      <Script
        src='https://view.ceros.com/scroll-proxy.min.js'
        data-ceros-origin-domains='view.ceros.com'
        strategy='beforeInteractive'
      />
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  try {
    const menu: HeaderNav = await safeAsync(
      () => getMenu('LEFT_MENU_COM', 'RIGHT_MENU_COM', 'TOPIC_NAVIGATION_COM', 'own', null),
      fallbackData.headerNav,
    );
    const footer = await safeAsync(() => getFooter(), fallbackData.footer);
    const arcSpanPageConfig: ArcSpanPageConfig = setarcSpanPageConfig(mockPageData);
    const pianoPageConfig: PianoPageConfig = setMockPianoConfig();
    const headData = { ...mockHeadData, canonicalUrl: '/advertising/', title: 'Advertising' };
    return {
      props: {
        arcSpanPageConfig,
        footer,
        headData,
        headerNav: menu,
        pianoPageConfig,
      },
      revalidate: 86400,
    };
  } catch (e) {
    return handleStaticPropsError(e as Error);
  }
};

export default AdvertisingPage;
